module.exports = __webpack_public_path__ + "01_glasses_red.be3e49f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer4/01_glasses_red.png
// module id = uukj
// module chunks = 0